import * as fc from 'utils/fieldConstants';
import { FieldType } from '../../types';

export const longFieldsWithoutCastType = [
  fc.CAMPAIGN,
  fc.CAMPAIGN_LABEL,
  fc.CANONICAL_URL,
  fc.CONTENT_ID,
  fc.EMAIL_CAMPAIGN,
  fc.EXIT_RULE_ID,
  fc.INTERNAL_USER_ID,
  fc.LIST_MEMBERSHIP,
  fc.MESSAGE_CHANNEL,
  fc.MESSAGE_ID,
  fc.MESSAGE_TYPE,
  fc.RECURRING_CAMPAIGN,
  fc.SUBSCRIBED_MESSAGE_TYPES,
  fc.TEMPLATE_ID,
  fc.TRIGGER_WORKFLOW,
  fc.UNSUBSCRIBED_CHANNEL,
  fc.UNSUBSCRIBED_CHANNELS,
  fc.UNSUBSCRIBED_MESSAGE_TYPE,
  fc.UNSUBSCRIBED_MESSAGE_TYPES,
  fc.USER_LIST_MEMBERSHIP,
  fc.USER_LIST_MEMBERSHIP_SINGLE,
  fc.WORKFLOW,
];

export const CAMPAIGN_LABEL_CATEGORY = {
  field: 'campaignLabelId',
  storedFieldType: FieldType.CAMPAIGN_LABEL_ID,
  fieldType: FieldType.INTEGER,
};

export const CAMPAIGN_FIELD = 'campaignId';
